import { createStore } from 'vuex';
import plugins from '../utils/plugins'
import userApi from '../api/user'

export default createStore({
    state: {
        isLogin: false,
        token: '',
        userInfo: {},//登录后用户信息
        userProfile: {},//用户详细信息（从接口获取）
        // 灰色默认加载头像（用于加载状态）
        defaultLoadingAvatar: 'https://api.dicebear.com/7.x/shapes/svg?seed=Bot&backgroundColor=d1d5db',
        // 默认头像集合（用于未设置 avatar 时的回退）
        defaultAvatars: [
            'https://api.dicebear.com/7.x/avataaars/svg?seed=Felix',
            'https://api.dicebear.com/7.x/avataaars/svg?seed=Aneka',
            'https://api.dicebear.com/7.x/avataaars/svg?seed=Luna',
            'https://api.dicebear.com/7.x/avataaars/svg?seed=Max',
            'https://api.dicebear.com/7.x/avataaars/svg?seed=Sophie',
            'https://api.dicebear.com/7.x/avataaars/svg?seed=Oliver',
            'https://api.dicebear.com/7.x/avataaars/svg?seed=Emma',
            'https://api.dicebear.com/7.x/avataaars/svg?seed=Jack',
            'https://api.dicebear.com/7.x/avataaars/svg?seed=Lily',
            'https://api.dicebear.com/7.x/avataaars/svg?seed=Noah',
            'https://api.dicebear.com/7.x/avataaars/svg?seed=Mia',
            'https://api.dicebear.com/7.x/avataaars/svg?seed=Leo',
            'https://api.dicebear.com/7.x/bottts/svg?seed=Trader',
            'https://api.dicebear.com/7.x/bottts/svg?seed=Quantum',
            'https://api.dicebear.com/7.x/bottts/svg?seed=Alpha',
            'https://api.dicebear.com/7.x/bottts/svg?seed=Beta',
            'https://api.dicebear.com/7.x/bottts/svg?seed=Gamma',
            'https://api.dicebear.com/7.x/bottts/svg?seed=Delta',
            'https://api.dicebear.com/7.x/bottts/svg?seed=Omega',
            'https://api.dicebear.com/7.x/bottts/svg?seed=Sigma',
            'https://api.dicebear.com/7.x/bottts/svg?seed=Zeta',
            'https://api.dicebear.com/7.x/bottts/svg?seed=Nova',
            'https://api.dicebear.com/7.x/bottts/svg?seed=Pulse',
            'https://api.dicebear.com/7.x/bottts/svg?seed=Spark',
            'https://api.dicebear.com/7.x/pixel-art/svg?seed=Crypto',
            'https://api.dicebear.com/7.x/pixel-art/svg?seed=Bot',
            'https://api.dicebear.com/7.x/pixel-art/svg?seed=Grid',
            'https://api.dicebear.com/7.x/pixel-art/svg?seed=Pixel',
            'https://api.dicebear.com/7.x/pixel-art/svg?seed=Retro',
            'https://api.dicebear.com/7.x/pixel-art/svg?seed=Arcade',
            'https://api.dicebear.com/7.x/pixel-art/svg?seed=Game',
            'https://api.dicebear.com/7.x/pixel-art/svg?seed=Bit',
            'https://api.dicebear.com/7.x/pixel-art/svg?seed=Chip',
            'https://api.dicebear.com/7.x/pixel-art/svg?seed=Code',
            'https://api.dicebear.com/7.x/pixel-art/svg?seed=Data',
            'https://api.dicebear.com/7.x/pixel-art/svg?seed=Byte',
            'https://api.dicebear.com/7.x/lorelei/svg?seed=Investor',
            'https://api.dicebear.com/7.x/lorelei/svg?seed=Whale',
            'https://api.dicebear.com/7.x/lorelei/svg?seed=Diamond',
            'https://api.dicebear.com/7.x/lorelei/svg?seed=Pearl',
            'https://api.dicebear.com/7.x/lorelei/svg?seed=Ruby',
            'https://api.dicebear.com/7.x/lorelei/svg?seed=Emerald',
            'https://api.dicebear.com/7.x/lorelei/svg?seed=Sapphire',
            'https://api.dicebear.com/7.x/lorelei/svg?seed=Gold',
            'https://api.dicebear.com/7.x/lorelei/svg?seed=Silver',
            'https://api.dicebear.com/7.x/lorelei/svg?seed=Crystal',
            'https://api.dicebear.com/7.x/lorelei/svg?seed=Jade',
            'https://api.dicebear.com/7.x/lorelei/svg?seed=Opal',
            'https://api.dicebear.com/7.x/fun-emoji/svg?seed=Happy',
            'https://api.dicebear.com/7.x/fun-emoji/svg?seed=Cool',
            'https://api.dicebear.com/7.x/fun-emoji/svg?seed=Rich',
            'https://api.dicebear.com/7.x/fun-emoji/svg?seed=Smart',
            'https://api.dicebear.com/7.x/fun-emoji/svg?seed=Lucky',
            'https://api.dicebear.com/7.x/fun-emoji/svg?seed=Chill',
            'https://api.dicebear.com/7.x/fun-emoji/svg?seed=Zen',
            'https://api.dicebear.com/7.x/fun-emoji/svg?seed=Star',
            'https://api.dicebear.com/7.x/fun-emoji/svg?seed=Moon',
            'https://api.dicebear.com/7.x/fun-emoji/svg?seed=Sun',
            'https://api.dicebear.com/7.x/fun-emoji/svg?seed=Fire',
            'https://api.dicebear.com/7.x/fun-emoji/svg?seed=Thunder',
            'https://api.dicebear.com/7.x/thumbs/svg?seed=Pro',
            'https://api.dicebear.com/7.x/thumbs/svg?seed=Master',
            'https://api.dicebear.com/7.x/thumbs/svg?seed=Expert',
            'https://api.dicebear.com/7.x/thumbs/svg?seed=Guru',
            'https://api.dicebear.com/7.x/thumbs/svg?seed=Ace',
            'https://api.dicebear.com/7.x/thumbs/svg?seed=Chief',
            'https://api.dicebear.com/7.x/thumbs/svg?seed=Prime',
            'https://api.dicebear.com/7.x/thumbs/svg?seed=Elite',
            'https://api.dicebear.com/7.x/thumbs/svg?seed=Top',
            'https://api.dicebear.com/7.x/thumbs/svg?seed=King',
            'https://api.dicebear.com/7.x/thumbs/svg?seed=Queen',
            'https://api.dicebear.com/7.x/thumbs/svg?seed=Boss',
        ],
        lang: 'en',//全球化参数
        loginTrigger: 0 // 增加一个触发器（数字每次+1）
    },
    getters: {
        getLogin(state) {
            return state.isLogin
        },
        getUserInfo(state) {
            if (state.isLogin) {
                return {
                    userId: plugins.getLocal('loginId'),
                    tokenName: plugins.getLocal('tokenName'),
                    tokenValue: plugins.getLocal('tokenValue'),
                    walletAddress: plugins.getLocal('walletAddress')
                }
            }
            else {
                return {}
            }
        },
        // 获取用户详细信息
        getUserProfile(state) {
            return state.userProfile
        }
        ,
        // 获取灰色默认加载头像
        getDefaultLoadingAvatar(state) {
            return state.defaultLoadingAvatar
        },
        // 获取默认头像集合
        getDefaultAvatars(state) {
            return state.defaultAvatars || []
        }
    },
    mutations: {
        setLogin(state, flag) {
            state.isLogin = !!flag;
        },
        setUserInfo(state, params) {
            if (params.tokenName && params.tokenValue) {
                for (let index in params) {
                    plugins.setLocal(index, params[index])
                }
                plugins.setLocal('tokenName', params['tokenName'])
                plugins.setLocal('tokenValue', params['tokenValue'])
                plugins.setLocal('walletAddress', params['walletAddress'])
            }
            else {
                plugins.deleteLocal("tokenName")
                plugins.deleteLocal("tokenValue")
                plugins.deleteLocal("walletAddress")
            }
        },
        // 设置用户详细信息
        setUserProfile(state, profile) {
            state.userProfile = profile || {}
        },
        triggerLogin(state) { state.loginTrigger += 1; }
    },
    actions: {
        toLogin({ commit, getters }) {
            if (getters.getLogin) {
                return true
            }
            else {
                commit('triggerLogin');
                return false
            }
        },
        // 获取用户详细信息
        async fetchUserProfile({ commit, getters }) {
            if (!getters.getLogin) {
                return null
            }
            try {
                const res = await userApi.info()
                if (res && res.data) {
                    commit('setUserProfile', res.data)
                    return res.data
                }
                return null
            } catch (error) {
                console.error('Failed to fetch user profile:', error)
                return null
            }
        },
        initAuth({ commit, dispatch }) {
            // 方式 A（同步）: 从本地读取 token 判断是否已登录
            // const tokenName = plugins.getLocal('tokenName');
            // const tokenValue = plugins.getLocal('tokenName');
            // if (tokenName && tokenValue) {
            //     commit('setUserInfo', { tokenName, tokenValue });
            //     commit('setLogin', true);
            //     return true;
            // }
            const tokenName = plugins.getLocal('tokenName');
            const tokenValue = plugins.getLocal('tokenValue');
            if (tokenName && tokenValue) {
                commit('setLogin', true);
                // 登录后自动获取用户详细信息
                dispatch('fetchUserProfile')
                return true;
            }
            else {
                commit('setLogin', false);
                return false;
            }
        },
        logOut({ commit }) {
            // 清理 Vuex 状态
            commit('setUserInfo', {});
            commit('setUserProfile', {});
            commit('setLogin', false);

            // 清理 localStorage 中的登录态
            plugins.deleteLocal('tokenName');
            plugins.deleteLocal('tokenValue');
            plugins.deleteLocal('walletAddress');
            plugins.deleteLocal('loginId');

            // 清理 sessionStorage 中的登录态
            window.sessionStorage.removeItem('metamaskAccount');
            window.sessionStorage.removeItem('avatarUrl');
            window.sessionStorage.removeItem('address');
        },
    },
})

